"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var DrawerCard = /** @class */ (function (_super) {
    __extends(DrawerCard, _super);
    function DrawerCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isOpen: false };
        _this.toggle = function () {
            _this.setState({
                isOpen: !_this.state.isOpen
            });
        };
        return _this;
    }
    DrawerCard.prototype.render = function () {
        var isOpen = this.state.isOpen;
        var _a = this.props, faceContent = _a.faceContent, _b = _a.style, style = _b === void 0 ? {} : _b, children = _a.children;
        return (React.createElement(Wrapper, { style: style },
            React.createElement(CardTop, { onClick: this.toggle },
                React.createElement(IconWrapper, null,
                    React.createElement(semantic_ui_react_1.Icon, { style: {
                            fontSize: '1.5rem',
                            display: 'inline-block',
                            height: '2rem',
                            width: '2rem',
                            marginRight: '2rem'
                        }, name: isOpen ? 'caret down' : 'caret right' }),
                    faceContent)),
            isOpen && children({ toggle: this.toggle })));
    };
    return DrawerCard;
}(React.Component));
exports.default = DrawerCard;
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  padding: 1.33rem 2rem;\n  border-radius: 1.33rem;\n  margin-bottom: 0.66rem;\n"], ["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  padding: 1.33rem 2rem;\n  border-radius: 1.33rem;\n  margin-bottom: 0.66rem;\n"])), theme_1.colors.white);
var CardTop = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var IconWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map